import { Controller } from "@hotwired/stimulus"

// Cercador amb llista desplegable sobre un endpoint JSON [{ id, label }].
// Desa l'id al camp ocult i emet «combobox:change» amb { id }.
export default class extends Controller {
  static targets = ["input", "hidden", "list"]
  static values = { url: String }

  search() {
    clearTimeout(this.timeout)
    const term = this.inputTarget.value.trim()
    if (term.length < 2) return this.close()
    this.timeout = setTimeout(() => this.fetch(term), 200)
  }

  async fetch(term) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", term)
    const response = await fetch(url, { headers: { Accept: "application/json" } })
    const items = await response.json()
    this.listTarget.replaceChildren(...items.map((item) => this.option(item)))
    this.listTarget.classList.toggle("hidden", items.length === 0)
  }

  option(item) {
    const button = document.createElement("button")
    button.type = "button"
    button.textContent = item.label
    button.dataset.id = item.id
    button.className = "block w-full rounded-lg px-3 py-2 text-start text-sm hover:bg-muted-hover"
    button.setAttribute("role", "option")
    button.addEventListener("click", () => this.choose(item))
    return button
  }

  choose(item) {
    this.hiddenTarget.value = item.id
    this.inputTarget.value = item.label
    this.close()
    this.dispatch("change", { detail: { id: item.id } })
  }

  close() {
    this.listTarget.classList.add("hidden")
  }
}
